import { withStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import "./CustomTabsStyle.scss"
const CustomTabs = withStyles((theme) => ({
}))(Tabs);

export default CustomTabs;
